/* pdp-engine 1.3.0 — generated by engine/tools/build_engine.py from engine/core/src; do not edit. */
(function () {
  'use strict';
  var PDP = {};

/* ---- util.js ---- */
/* Small DOM and formatting helpers shared by every module. */
PDP.util = (function () {
  'use strict';
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  // "{name} — {taste|lower}" with fields { name, taste }; unknown tokens stay as written
  function fmt(template, fields) {
    return String(template).replace(/\{(\w+)(?:\|(lower|upper))?\}/g, function (m, key, mod) {
      if (!fields || !(key in fields)) return m;
      var v = String(fields[key]);
      if (mod === 'lower') return v.toLowerCase();
      if (mod === 'upper') return v.toUpperCase();
      return v;
    });
  }
  function reducedMotion() {
    return !!(typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  return { $: $, $$: $$, money: money, fmt: fmt, reducedMotion: reducedMotion };
})();

/* ---- config.js ---- */
/* Engine config: read the page's JSON config and answer questions about tiers, axes and variants.
   The page carries <script type="application/json" data-pdp-config>; see engine/README.md for the schema. */
PDP.config = (function () {
  'use strict';
  var DEFAULT_LABELS = {
    add: 'Add to cart',
    soldOut: 'Sold out',
    slot: 'Unit {n}',
    slotSingle: 'Option',
    legendOne: 'Choose your option',
    legendMany: 'Choose your options',
    hintMany: 'Mix and match',
    oneOfEach: 'One of each',
    save: '{label} · save {pct}%',
    perServing: '{price} per serving · {servings} servings',
    shipsFree: 'Ships free',
    shipGap: '{gap} from free shipping · {tier} ship free',
    shipOver: 'Free shipping on orders over ${threshold}',
    addonShip: 'Unlocks free shipping'
  };

  function tier(c, id) {
    for (var i = 0; i < c.tiers.length; i++) if (c.tiers[i].id === id) return c.tiers[i];
    return null;
  }
  function tierIndex(c, id) {
    for (var i = 0; i < c.tiers.length; i++) if (c.tiers[i].id === id) return i;
    return -1;
  }
  function unitAxis(c) {
    for (var i = 0; i < c.axes.length; i++) if (c.axes[i].perUnit) return c.axes[i];
    return null;
  }
  function singleAxes(c) { return c.axes.filter(function (a) { return !a.perUnit; }); }

  function normalize(raw) {
    var c = JSON.parse(JSON.stringify(raw || {}));
    c.mode = c.mode === 'shopify' ? 'shopify' : 'static';
    c.store = c.mode === 'shopify' ? '' : (c.store || '');
    c.product = c.product || {};
    c.axes = (c.axes || []).map(function (a) {
      return { key: String(a.key), label: a.label || String(a.key), perUnit: !!a.perUnit, values: a.values || {} };
    });
    if (c.axes.filter(function (a) { return a.perUnit; }).length > 1) throw new Error('pdp: only one per-unit axis is supported');
    c.variants = (c.variants || []).map(function (v) {
      return { id: String(v.id), options: v.options || {}, priceCents: Math.round(Number(v.price) * 100), available: v.available !== false };
    });
    if (!c.variants.length) throw new Error('pdp: config has no variants');
    c.tiers = (c.tiers && c.tiers.length ? c.tiers : [{ id: 'one', qty: 1, discount: 0, label: '' }]).map(function (t) {
      return { id: String(t.id), qty: Number(t.qty) || 1, discount: Number(t.discount) || 0, label: t.label || '', code: t.code || '', bar: t.bar || '' };
    });
    c.showTiers = c.showTiers !== false;
    c.defaultTier = tier(c, c.defaultTier) ? c.defaultTier : c.tiers[0].id;
    c.oneOfEachTier = tier(c, c.oneOfEachTier) ? c.oneOfEachTier : null;
    c.freeShipping = Number(c.freeShipping) || 0;
    c.kaching = c.kaching && c.kaching.deal ? { deal: String(c.kaching.deal) } : null;
    // add-ons: another product's variant that rides along with the pick on Add to cart, never added on its own
    c.addons = (c.addons || []).filter(function (a) { return a && a.id != null && a.variant; }).map(function (a) {
      return { id: String(a.id), handle: a.handle || '', variant: String(a.variant), name: a.name || '',
               priceCents: Math.round(Number(a.price) * 100), available: a.available !== false };
    });
    c.assets = {
      base: c.assets && c.assets.base != null ? c.assets.base : 'public/assets/',
      urls: (c.assets && c.assets.urls) || {}
    };
    c.initial = c.initial || {};
    c.labels = Object.assign({}, DEFAULT_LABELS, c.labels || {});
    c.jumpOffset = c.jumpOffset == null ? 72 : Number(c.jumpOffset);
    c.buyAnchor = c.buyAnchor || '#buy';
    return c;
  }

  function read(doc) {
    var el = doc.querySelector('script[type="application/json"][data-pdp-config]');
    if (!el) throw new Error('pdp: no <script type="application/json" data-pdp-config> on the page');
    return normalize(JSON.parse(el.textContent));
  }

  // the variant for the chosen single-axis values plus one per-unit value (null when the product has no per-unit axis)
  function variantFor(c, single, unitValue) {
    var ua = unitAxis(c), singles = singleAxes(c);
    for (var i = 0; i < c.variants.length; i++) {
      var v = c.variants[i], ok = true;
      for (var j = 0; j < singles.length; j++) {
        var k = singles[j].key;
        if (single && single[k] != null && v.options[k] !== single[k]) { ok = false; break; }
      }
      if (ok && ua && v.options[ua.key] !== unitValue) ok = false;
      if (ok) return v;
    }
    return null;
  }
  function valueAvailable(c, single, unitValue) {
    var v = variantFor(c, single, unitValue);
    return !!(v && v.available);
  }
  function variantById(c, id) {
    for (var i = 0; i < c.variants.length; i++) if (c.variants[i].id === String(id)) return c.variants[i];
    return null;
  }
  function addon(c, id) {
    for (var i = 0; i < c.addons.length; i++) if (c.addons[i].id === String(id)) return c.addons[i];
    return null;
  }

  return {
    DEFAULT_LABELS: DEFAULT_LABELS, normalize: normalize, read: read, tier: tier, tierIndex: tierIndex,
    unitAxis: unitAxis, singleAxes: singleAxes, variantFor: variantFor, valueAvailable: valueAvailable, variantById: variantById,
    addon: addon
  };
})();

/* ---- pricing.js ---- */
/* Tier prices in cents. Kaching Bundles takes the tier's % off each unit and truncates it to the cent
   (10% of $39.99 = $3.99), so 2 × $39.99 at 10% off is $72.00, not $71.98. */
PDP.pricing = (function () {
  'use strict';
  function unitOffCents(priceCents, discount) {
    return Math.floor(Math.round(priceCents * discount * 100) / 100);
  }
  function tierMath(c, tierId, units) {
    var t = PDP.config.tier(c, tierId);
    var compare = 0, price = 0;
    (units || []).forEach(function (v) {
      if (!v) return;
      compare += v.priceCents;
      price += v.priceCents - unitOffCents(v.priceCents, t.discount);
    });
    var servings = (Number(c.product.servings) || 0) * t.qty;
    return { compareCents: compare, priceCents: price, servings: servings, perServingCents: servings ? Math.round(price / servings) : 0 };
  }
  function repeat(v, n) { var out = []; for (var i = 0; i < n; i++) out.push(v); return out; }
  // add-ons sell at their own full price: no tier discount and no Kaching property (cart.js)
  function addonCents(items) {
    return (items || []).reduce(function (sum, a) { return sum + a.priceCents; }, 0);
  }
  return { unitOffCents: unitOffCents, tierMath: tierMath, repeat: repeat, addonCents: addonCents };
})();

/* ---- state.js ---- */
/* Buyer state: the tier, one value of the per-unit axis per unit (slots) and the single-choice axes. */
PDP.state = (function () {
  'use strict';
  var cfg = PDP.config;

  // a malformed percent-escape (a stray campaign param, a truncated fbclid) must not abort boot: fall back to the raw text
  function dec(x) { try { return decodeURIComponent(x); } catch (e) { return x; } }

  function parseSearch(search) {
    var out = {};
    String(search || '').replace(/^\?/, '').split('&').forEach(function (p) {
      if (!p) return;
      var i = p.indexOf('=');
      var k = dec(i < 0 ? p : p.slice(0, i));
      out[k] = i < 0 ? '' : dec(p.slice(i + 1).replace(/\+/g, ' '));
    });
    return out;
  }

  function firstAvailable(c, s) {
    var keys = Object.keys(cfg.unitAxis(c).values);
    for (var i = 0; i < keys.length; i++) if (cfg.valueAvailable(c, s.single, keys[i])) return keys[i];
    return keys[0];
  }

  function fit(c, s) {
    var n = cfg.tier(c, s.tier).qty;
    if (!cfg.unitAxis(c)) {
      s.slots = [];
      for (var i = 0; i < n; i++) s.slots.push(null);
      return;
    }
    if (!s.slots.length) s.slots.push(cfg.valueAvailable(c, s.single, s.value) ? s.value : firstAvailable(c, s));
    while (s.slots.length < n) s.slots.push(s.slots[s.slots.length - 1]);  // new units copy the last pick
    s.slots.length = n;
  }

  function create(c, search) {
    // add-ons start unticked: a pre-ticked extra item is the shopper's money spent without asking
    var s = { tier: c.showTiers ? c.defaultTier : c.tiers[0].id, slots: [], single: {}, value: null, slide: 0, addons: [] };
    var ua = cfg.unitAxis(c);
    cfg.singleAxes(c).forEach(function (a) {
      s.single[a.key] = a.values[c.initial[a.key]] ? c.initial[a.key] : Object.keys(a.values)[0];
    });
    if (ua) s.value = ua.values[c.initial[ua.key]] ? c.initial[ua.key] : Object.keys(ua.values)[0];
    var q = parseSearch(search);
    if (q.variant) {
      var v = cfg.variantById(c, q.variant);
      if (v) c.axes.forEach(function (a) {
        var val = v.options[a.key];
        if (val == null) return;
        if (a.perUnit) s.value = val; else s.single[a.key] = val;
      });
    }
    c.axes.forEach(function (a) {
      var val = q[a.key];
      if (val && a.values[val]) { if (a.perUnit) s.value = val; else s.single[a.key] = val; }
    });
    if (q.tier && cfg.tier(c, q.tier) && (c.showTiers || q.tier === c.tiers[0].id)) s.tier = q.tier;
    if (ua && !cfg.valueAvailable(c, s.single, s.value)) s.value = firstAvailable(c, s);
    fit(c, s);
    return s;
  }

  function setSlot(c, s, i, value) {
    if (!cfg.unitAxis(c) || i >= s.slots.length || s.slots[i] === value || !cfg.valueAvailable(c, s.single, value)) return false;
    s.slots[i] = value;
    s.value = value;
    return true;
  }

  // flavor tiles further down the page: every unit in the current quantity becomes that value
  function setAll(c, s, value) {
    if (!cfg.unitAxis(c) || !cfg.valueAvailable(c, s.single, value)) return false;
    s.slots = s.slots.map(function () { return value; });
    s.value = value;
    return true;
  }

  function setTier(c, s, id) {
    if (!cfg.tier(c, id) || id === s.tier) return false;
    if (!c.showTiers && id !== c.tiers[0].id) return false;
    s.tier = id;
    fit(c, s);
    if (cfg.unitAxis(c) && s.slots.indexOf(s.value) === -1) s.value = s.slots[s.slots.length - 1];
    return true;
  }

  function setSingle(c, s, key, value) {
    var axis = null;
    cfg.singleAxes(c).forEach(function (a) { if (a.key === key) axis = a; });
    if (!axis || !axis.values[value] || s.single[key] === value) return false;
    s.single[key] = value;
    if (cfg.unitAxis(c)) {
      s.slots = s.slots.map(function (v) { return cfg.valueAvailable(c, s.single, v) ? v : firstAvailable(c, s); });
      if (s.slots.indexOf(s.value) === -1) s.value = s.slots[s.slots.length - 1];
    }
    return true;
  }

  function oneOfEach(c, s) {
    var ua = cfg.unitAxis(c);
    if (!ua || !c.showTiers || !c.oneOfEachTier) return false;
    s.tier = c.oneOfEachTier;
    s.slots = Object.keys(ua.values).map(function (k) { return cfg.valueAvailable(c, s.single, k) ? k : firstAvailable(c, s); });
    fit(c, s);
    if (s.slots.indexOf(s.value) === -1) s.value = s.slots[0];
    return true;
  }

  function units(c, s) {
    return s.slots.map(function (v) { return cfg.variantFor(c, s.single, v); });
  }

  // tick or untick an add-on; a sold-out one can't be ticked
  function setAddon(c, s, id, on) {
    var a = cfg.addon(c, id);
    var i = s.addons.indexOf(String(id));
    if (!a || (on ? i !== -1 || !a.available : i === -1)) return false;
    if (on) s.addons.push(a.id); else s.addons.splice(i, 1);
    return true;
  }

  // the ticked add-ons that can go in the cart, in config order
  function addonItems(c, s) {
    return c.addons.filter(function (a) { return a.available && s.addons.indexOf(a.id) !== -1; });
  }

  function describe(c, s) {
    var t = cfg.tier(c, s.tier), ua = cfg.unitAxis(c);
    var extra = addonItems(c, s).map(function (a) { return ' + ' + (a.name || a.id); }).join('');
    if (!ua) return t.label + extra;
    var count = {}, order = [];
    s.slots.forEach(function (v) { if (!(v in count)) { count[v] = 0; order.push(v); } count[v]++; });
    var n = Object.keys(ua.values).length;
    var text = (n > 1 && s.slots.length === n && order.length === n)
      ? c.labels.oneOfEach
      : order.map(function (v) { return (ua.values[v].name || v) + (count[v] > 1 ? ' ×' + count[v] : ''); }).join(' + ');
    return t.label + ' · ' + text + extra;
  }

  return {
    parseSearch: parseSearch, create: create, fit: fit, setSlot: setSlot, setAll: setAll, setTier: setTier,
    setSingle: setSingle, oneOfEach: oneOfEach, units: units, setAddon: setAddon, addonItems: addonItems, describe: describe
  };
})();

/* ---- cart.js ---- */
/* Cart: static pages link to Shopify cart permalinks; Shopify mode posts /cart/add.js and opens the Kaching drawer.
   Kaching Bundles only discounts lines that carry its __kaching_bundles property (deal nanoId + deal-bar id + product
   id) — the same payload its own widget posts. Ticked add-ons go in the same request after the pick, as plain
   full-price lines: there is no way to add one without the pick (Chris, 2026-10-02). Shopify's /cart/add.js is
   all-or-nothing (one sold-out item: 422, nothing added), so a failed add with add-ons retries the pick alone. */
PDP.cart = (function () {
  'use strict';
  function kachingProps(c, tierId) {
    var t = PDP.config.tier(c, tierId);
    if (!c.kaching || !t || !t.bar) return null;
    return { __kaching_bundles: JSON.stringify({ deal: c.kaching.deal, pp: Number(c.product.id), main: true, bid: t.bar }) };
  }

  function pickLines(c, s) {
    var qty = {}, order = [];
    PDP.state.units(c, s).forEach(function (v) {
      if (!v) return;
      if (!(v.id in qty)) { qty[v.id] = 0; order.push(v.id); }
      qty[v.id]++;
    });
    var props = kachingProps(c, s.tier);
    return order.map(function (id) {
      var l = { id: Number(id), quantity: qty[id] };
      if (props) l.properties = props;
      return l;
    });
  }

  function addonLines(c, s) {
    return PDP.state.addonItems(c, s).map(function (a) { return { id: Number(a.variant), quantity: 1 }; });
  }

  function lines(c, s) {
    var pick = pickLines(c, s);
    return pick.length ? pick.concat(addonLines(c, s)) : pick;
  }

  function permalink(c, s) {
    var t = PDP.config.tier(c, s.tier);
    var items = lines(c, s).map(function (l) { return l.id + ':' + l.quantity; }).join(',');
    return c.store + '/cart/' + items + (t.code ? '?discount=' + encodeURIComponent(t.code) : '');
  }

  function openDrawer(win) {
    var k = win.kachingCartApi;
    if (!k || typeof k.openCart !== 'function') { win.location.href = '/cart'; return Promise.resolve(); }
    return Promise.resolve(typeof k.refreshCart === 'function' ? k.refreshCart() : null)
      .catch(function () {})
      .then(function () { k.openCart(); });
  }

  function post(win, items) {
    return win.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }

  function add(c, s, btn, win) {
    var t = PDP.config.tier(c, s.tier);
    var all = lines(c, s), pick = pickLines(c, s);
    btn.classList.add('is-busy');
    return post(win, all)
      .catch(function (e) { if (all.length === pick.length) throw e; return post(win, pick); })
      .then(function () {
        if (t.code) { win.location.href = '/discount/' + encodeURIComponent(t.code) + '?redirect=%2Fcart'; return null; }
        btn.classList.remove('is-busy');
        return openDrawer(win);
      })
      .catch(function () { btn.classList.remove('is-busy'); win.location.href = '/cart'; });
  }

  return {
    kachingProps: kachingProps, pickLines: pickLines, addonLines: addonLines, lines: lines, permalink: permalink,
    openDrawer: openDrawer, add: add
  };
})();

/* ---- track.js ---- */
/* Tracking hooks: every interaction pushes a plain object to window.dataLayer (when the page has one) and dispatches
   a `pdp:track` DOM event. gtag.js ignores object pushes; a GTM container could listen for them. */
PDP.track = (function () {
  'use strict';
  function send(c, s, name, detail, win, doc) {
    var payload = { event: name };
    var ua = PDP.config.unitAxis(c);
    if (ua) payload[ua.key] = s.value;
    payload.tier = s.tier;
    Object.keys(detail || {}).forEach(function (k) { payload[k] = detail[k]; });
    if (win.dataLayer && typeof win.dataLayer.push === 'function') win.dataLayer.push(payload);
    if (typeof win.CustomEvent === 'function') doc.dispatchEvent(new win.CustomEvent('pdp:track', { detail: payload }));
    return payload;
  }
  return { send: send };
})();

/* ---- render.js ---- */
/* Render the buyer state into the page through its data hooks. Safe to call after every change. */
PDP.render = (function () {
  'use strict';
  var u = PDP.util, cfg = PDP.config;
  var CTA = '[data-cta], [data-cta-mid], [data-cta-final], [data-cta-sticky]';

  function assetUrl(c, path) { return c.assets.urls[path] || (c.assets.base + path); }

  // template fields: {title}, each single axis key → value key, and the current per-unit value's fields + {<axis key>}
  function fields(c, s) {
    var f = { title: c.product.title || '' };
    Object.keys(s.single).forEach(function (k) { f[k] = s.single[k]; });
    var ua = cfg.unitAxis(c);
    if (ua && s.value) {
      Object.keys(ua.values[s.value] || {}).forEach(function (k) { f[k] = ua.values[s.value][k]; });
      f[ua.key] = s.value;
      f.key = s.value;
    }
    return f;
  }

  function setSrc(img, src) { if (img.getAttribute('src') !== src) img.setAttribute('src', src); }

  // honest free-shipping line: only promise it when the next tier up actually crosses the threshold. extraCents is
  // the ticked add-ons, which ride along with any tier
  function shipNote(c, s, m, extraCents) {
    if (!c.freeShipping) return '';
    var extra = extraCents || 0;
    var threshold = Math.round(c.freeShipping * 100), gap = threshold - m.priceCents - extra;
    if (gap <= 0) return c.labels.shipsFree;
    var next = c.tiers[cfg.tierIndex(c, s.tier) + 1];
    if (c.showTiers && next) {
      var rep = cfg.variantFor(c, s.single, s.value);
      var nm = PDP.pricing.tierMath(c, next.id, PDP.pricing.repeat(rep, next.qty));
      if (nm.priceCents + extra >= threshold) return u.fmt(c.labels.shipGap, { gap: u.money(gap), tier: next.label });
    }
    return u.fmt(c.labels.shipOver, { threshold: c.freeShipping });
  }

  // an add-on row says it unlocks free shipping only when ticking it is what takes the order over the threshold
  function addonShip(c, a, pickCents, otherCents) {
    if (!c.freeShipping) return '';
    var threshold = Math.round(c.freeShipping * 100), before = pickCents + otherCents;
    return before < threshold && before + a.priceCents >= threshold ? c.labels.addonShip : '';
  }

  function renderAddons(c, s, doc, m, items) {
    u.$$('[data-addon]', doc).forEach(function (row) {
      var a = cfg.addon(c, row.getAttribute('data-addon'));
      row.hidden = !a || !a.available;
      if (row.hidden) return;
      var on = s.addons.indexOf(a.id) !== -1;
      row.classList.toggle('is-selected', on);
      var input = row.querySelector('input'); if (input) input.checked = on;
      u.$$('[data-addon-price]', row).forEach(function (el) { el.textContent = u.money(a.priceCents); });
      var others = PDP.pricing.addonCents(items.filter(function (x) { return x.id !== a.id; }));
      var ship = addonShip(c, a, m.priceCents, others);
      u.$$('[data-addon-ship]', row).forEach(function (el) { el.textContent = ship; el.hidden = !ship; });
    });
  }

  function run(c, s, doc) {
    var ua = cfg.unitAxis(c), t = cfg.tier(c, s.tier);
    var m = PDP.pricing.tierMath(c, s.tier, PDP.state.units(c, s));
    var f = fields(c, s);

    if (ua) {
      doc.documentElement.setAttribute('data-' + ua.key, s.value);
      u.$$('[data-pdp-root]', doc).forEach(function (r) { r.setAttribute('data-' + ua.key, s.value); });
    }
    u.$$('[data-swap-src]', doc).forEach(function (img) {
      // a playing video keeps playing its new source (setting src pauses it)
      var playing = img.tagName === 'VIDEO' && !img.paused;
      setSrc(img, assetUrl(c, u.fmt(img.getAttribute('data-swap-src'), f)));
      if (playing && img.paused && img.play) { var p = img.play(); if (p && p.catch) p.catch(function () {}); }
      var alt = img.getAttribute('data-swap-alt');
      if (alt != null) img.setAttribute('alt', u.fmt(alt, f));
    });
    // a video's poster follows the pick too, so a paused or reduced-motion video shows the right pack
    u.$$('[data-swap-poster]', doc).forEach(function (v) {
      var p = assetUrl(c, u.fmt(v.getAttribute('data-swap-poster'), f));
      if (v.getAttribute('poster') !== p) v.setAttribute('poster', p);
    });
    u.$$('[data-text]', doc).forEach(function (el) { el.textContent = u.fmt(el.getAttribute('data-text'), f); });

    var n = s.slots.length;
    u.$$('[data-slot]', doc).forEach(function (row) {
      var i = parseInt(row.getAttribute('data-slot'), 10);
      row.hidden = !ua || i >= n;
      if (row.hidden) return;
      var k = s.slots[i];
      u.$$('input', row).forEach(function (inp) { inp.checked = inp.value === k; });
      u.$$('[data-swatch]', row).forEach(function (sw) { sw.classList.toggle('is-selected', sw.getAttribute('data-swatch') === k); });
      u.$$('[data-slot-label]', row).forEach(function (el) { el.textContent = n > 1 ? u.fmt(c.labels.slot, { n: i + 1 }) : c.labels.slotSingle; });
      u.$$('[data-slot-text]', row).forEach(function (el) {
        el.textContent = u.fmt(el.getAttribute('data-slot-text'), Object.assign({ key: k }, ua.values[k]));
      });
    });
    u.$$('[data-slot-legend]', doc).forEach(function (el) { el.textContent = n > 1 ? c.labels.legendMany : c.labels.legendOne; });
    u.$$('[data-slot-hint]', doc).forEach(function (el) { el.textContent = n > 1 ? c.labels.hintMany : ''; });
    u.$$('[data-value-tile]', doc).forEach(function (el) { el.classList.toggle('is-selected', s.slots.indexOf(el.getAttribute('data-value-tile')) !== -1); });
    u.$$('[data-tier]', doc).forEach(function (el) {
      var on = el.getAttribute('data-tier') === s.tier;
      el.classList.toggle('is-selected', on);
      var input = el.querySelector('input'); if (input) input.checked = on;
    });
    u.$$('[data-axis-option]', doc).forEach(function (el) {
      var p = el.getAttribute('data-axis-option').split(':');
      var on = s.single[p[0]] === p[1];
      el.classList.toggle('is-selected', on);
      var input = el.querySelector('input'); if (input) input.checked = on;
    });

    // tier prices use the current unit repeated, so a price change in the config is one edit
    var rep = cfg.variantFor(c, s.single, s.value);
    c.tiers.forEach(function (tt) {
      var tm = PDP.pricing.tierMath(c, tt.id, PDP.pricing.repeat(rep, tt.qty));
      u.$$('[data-tier-price="' + tt.id + '"]', doc).forEach(function (el) { el.textContent = u.money(tm.priceCents); });
      u.$$('[data-tier-compare="' + tt.id + '"]', doc).forEach(function (el) { el.textContent = u.money(tm.compareCents); });
    });

    // a button's price is what it adds (the pick and any ticked add-on); the title block's is the pick alone
    var items = PDP.state.addonItems(c, s), extra = PDP.pricing.addonCents(items);
    u.$$('[data-cta-price]', doc).forEach(function (el) { el.textContent = u.money(m.priceCents + extra); });
    u.$$('[data-head-price]', doc).forEach(function (el) { el.textContent = u.money(m.priceCents); });
    renderAddons(c, s, doc, m, items);
    var href = PDP.cart.permalink(c, s);
    u.$$(CTA, doc).forEach(function (a) { if (a.tagName === 'A') a.setAttribute('href', href); });
    u.$$('[data-head-compare]', doc).forEach(function (el) { el.textContent = u.money(m.compareCents); el.hidden = !t.discount; });
    u.$$('[data-head-save]', doc).forEach(function (el) {
      el.textContent = t.discount ? u.fmt(c.labels.save, { label: t.label, pct: Math.round(t.discount * 100) }) : t.label;
    });
    u.$$('[data-per-serving]', doc).forEach(function (el) {
      el.textContent = u.fmt(c.labels.perServing, { price: u.money(m.perServingCents), servings: m.servings });
    });
    u.$$('[data-pick-summary]', doc).forEach(function (el) { el.textContent = PDP.state.describe(c, s); });
    u.$$('[data-ship-note]', doc).forEach(function (el) { el.textContent = shipNote(c, s, m, extra); });

    // availability: sold-out values can't be picked; the buttons lock if a picked unit is sold out
    var avail = PDP.state.units(c, s).every(function (v) { return v && v.available; });
    u.$$(CTA, doc).forEach(function (b) {
      b.classList.toggle('is-disabled', !avail);
      b.setAttribute('aria-disabled', avail ? 'false' : 'true');
      var lbl = b.querySelector('span:first-child'); if (lbl) lbl.textContent = avail ? c.labels.add : c.labels.soldOut;
    });
    u.$$('[data-swatch]', doc).forEach(function (el) {
      var ok = cfg.valueAvailable(c, s.single, el.getAttribute('data-swatch'));
      el.classList.toggle('is-soldout', !ok);
      var inp = el.querySelector('input'); if (inp) inp.disabled = !ok;
    });
  }

  // a missing generated image must never leave a broken image: swap to the fallback once
  function bindFallbacks(c, s, doc) {
    u.$$('[data-swap-fallback]', doc).forEach(function (img) {
      img.addEventListener('error', function () {
        var fb = assetUrl(c, u.fmt(img.getAttribute('data-swap-fallback'), fields(c, s)));
        if (img.getAttribute('src') !== fb) img.setAttribute('src', fb);
      });
    });
  }

  return { run: run, assetUrl: assetUrl, fields: fields, shipNote: shipNote, addonShip: addonShip, bindFallbacks: bindFallbacks, CTA: CTA };
})();

/* ---- gallery.js ---- */
/* Gallery: scroll-snap track, arrows, thumbs, arrow keys; videos play only on their active slide while in view. */
PDP.gallery = (function () {
  'use strict';
  var u = PDP.util;
  function syncVideos(videos, activeIndex, inView) {
    videos.forEach(function (v) {
      var slide = v.closest('[data-slide]');
      var idx = slide ? parseInt(slide.getAttribute('data-slide'), 10) : -1;
      if (inView !== false && idx === activeIndex && !u.reducedMotion()) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }
  function init(s, doc, win, track) {
    var gallery = u.$('[data-gallery]', doc);
    if (!gallery) return { sync: function () {} };
    var videos = u.$$('video', gallery);
    var trackEl = u.$('[data-gallery-track]', gallery);
    var slides = u.$$('[data-slide]', gallery);
    var thumbs = u.$$('[data-thumb]', gallery);
    var ticking = false;
    function setActive(i) {
      if (i === s.slide) return;
      s.slide = i;
      slides.forEach(function (sl, k) { sl.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (b, k) { if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      syncVideos(videos, i);
      track('gallery_slide', { slide: i });
    }
    function goTo(i, smooth) {
      if (!trackEl) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      trackEl.scrollTo({ left: i * trackEl.clientWidth, behavior: (smooth === false || u.reducedMotion()) ? 'auto' : 'smooth' });
      setActive(i);
    }
    if (trackEl) {
      trackEl.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        win.requestAnimationFrame(function () { ticking = false; setActive(Math.round(trackEl.scrollLeft / trackEl.clientWidth)); });
      });
      trackEl.setAttribute('tabindex', '0');
      trackEl.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(s.slide + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(s.slide - 1); }
      });
      win.addEventListener('resize', function () { trackEl.scrollLeft = s.slide * trackEl.clientWidth; });
    }
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { goTo(k); }); });
    var prev = u.$('[data-gallery-prev]', gallery), next = u.$('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { goTo(s.slide - 1); });
    if (next) next.addEventListener('click', function () { goTo(s.slide + 1); });
    if ('IntersectionObserver' in win && videos.length) {
      new win.IntersectionObserver(function (entries) { syncVideos(videos, s.slide, entries[0].isIntersecting); }, { threshold: 0.25 }).observe(gallery);
    }
    return { sync: function () { syncVideos(videos, s.slide); } };
  }
  return { init: init };
})();

/* ---- sticky.js ---- */
/* Sticky add-to-cart (a bar on every width + optional masthead button). The bar docks under the page's sticky header
   (--masthead-h on [data-pdp-root]; Dawn's header on Shopify), in the reading line (Chris, 2026-09-30: a bar at the
   bottom was out of sight); a page may still dock it at the bottom. Shows once the first Add to cart has scrolled
   away: the gallery, or the buy box's button when the gallery is sticky (a two-column desktop, where the gallery
   stays on screen for the whole buy box). Steps aside whenever a full-size Add to cart button is on screen, "on
   screen" meaning between the sticky header (and a top bar) and the bottom of the screen (or a bottom bar). Toggles
   html.has-stickybar for other fixed widgets. */
PDP.sticky = (function () {
  'use strict';
  var u = PDP.util;
  function init(doc, win) {
    var bar = u.$('[data-stickybar]', doc), mast = u.$('[data-sticky-mast]', doc);
    var buyCta = u.$('[data-cta]', doc), galleryEl = u.$('[data-gallery]', doc);
    var inline = u.$$('[data-cta], [data-cta-mid], [data-cta-final]', doc);
    var root = doc.querySelector('[data-pdp-root]');
    if (!buyCta) return;
    function update() {
      var top = (root && parseFloat(win.getComputedStyle(root).getPropertyValue('--masthead-h'))) || 0;
      // a bar docked at the top covers the band under the header; one at the bottom the band above the fold
      var atTop = !!bar && bar.offsetTop < win.innerHeight / 2;
      var from = top + (atTop ? bar.offsetHeight : 0);
      var bottom = win.innerHeight - (bar && !atTop ? bar.offsetHeight : 0);
      var anchor = galleryEl && win.getComputedStyle(galleryEl).position !== 'sticky' ? galleryEl : buyCta;
      var ctaOnScreen = inline.some(function (el) {
        var r = el.getBoundingClientRect();
        return r.height > 0 && r.bottom > from && r.top < bottom;
      });
      var show = anchor.getBoundingClientRect().bottom < top && !ctaOnScreen;
      if (bar) { bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true'); }
      if (mast) mast.classList.toggle('is-visible', show);
      doc.documentElement.classList.toggle('has-stickybar', show);
      doc.documentElement.classList.toggle('has-stickybar-bottom', show && !atTop);
    }
    // re-check on scroll and resize (a fast fling can skip past an element), and when a CTA's intersection changes
    // without a scroll (reviews or images loading above it)
    var tick = false;
    function request() {
      if (tick) return; tick = true;
      win.requestAnimationFrame(function () { tick = false; update(); });
    }
    win.addEventListener('scroll', request, { passive: true });
    win.addEventListener('resize', request);
    if ('IntersectionObserver' in win) inline.forEach(function (el) { new win.IntersectionObserver(request).observe(el); });
    update();
  }
  return { init: init };
})();

/* ---- faq.js ---- */
/* FAQ: one answer open at a time, each opening tracked. */
PDP.faq = (function () {
  'use strict';
  var u = PDP.util;
  function init(doc, track) {
    u.$$('[data-faq]', doc).forEach(function (faq) {
      var items = u.$$('details', faq);
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
          var sum = d.querySelector('summary');
          track('faq_open', { question: sum ? sum.textContent.trim() : '' });
        });
      });
    });
  }
  return { init: init };
})();

/* ---- reveal.js ---- */
/* Scroll reveals (adds .is-in; ?static adds html.is-static and shows everything, for captures) and ambient videos
   that play only in view and never under reduced motion. The reveal look itself lives in each product's CSS. */
PDP.reveal = (function () {
  'use strict';
  var u = PDP.util;
  function init(doc, win) {
    var staticMode = /[?&]static\b/.test(win.location.search);
    if (staticMode) doc.documentElement.classList.add('is-static');
    var items = u.$$('[data-reveal]', doc);
    if ('IntersectionObserver' in win && !u.reducedMotion() && !staticMode) {
      var io = new win.IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { threshold: 0.12 });
      items.forEach(function (el) { io.observe(el); });
    } else {
      items.forEach(function (el) { el.classList.add('is-in'); });
    }
    var ambient = u.$$('[data-ambient-video]', doc);
    if (!ambient.length) return;
    if (u.reducedMotion()) { ambient.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); }); return; }
    if ('IntersectionObserver' in win) {
      var aio = new win.IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
        });
      }, { threshold: 0.2 });
      ambient.forEach(function (v) { aio.observe(v); });
    }
  }
  return { init: init };
})();

/* ---- boot.js ---- */
/* Wire the engine to the page. The bundle calls PDP.boot(document, window) once the DOM is parsed. */
function pdpHeaderOffset(doc, win) {
  // Shopify: keep sticky columns clear of the theme's sticky header (Dawn's is 174px on desktop)
  var root = doc.querySelector('[data-pdp-root]');
  if (!root) return;
  function set() {
    var hdr = doc.querySelector('sticky-header, .header-wrapper, .shopify-section-header-sticky');
    var pos = hdr ? win.getComputedStyle(hdr).position : '';
    var sticky = hdr && (pos === 'sticky' || pos === 'fixed' || doc.querySelector('sticky-header'));
    root.style.setProperty('--masthead-h', (sticky ? Math.round(hdr.getBoundingClientRect().height) : 0) + 'px');
  }
  set();
  win.addEventListener('resize', set);
}

PDP.boot = function (doc, win) {
  'use strict';
  var u = PDP.util;
  var c = PDP.config.read(doc);
  var s = PDP.state.create(c, win.location.search);
  function render() { PDP.render.run(c, s, doc); }
  function track(name, detail) { return PDP.track.send(c, s, name, detail, win, doc); }
  function jumpToBuy() {
    var buy = doc.querySelector(c.buyAnchor);
    if (!buy) return;
    var top = buy.getBoundingClientRect().top + win.pageYOffset - c.jumpOffset;
    win.scrollTo({ top: top, behavior: u.reducedMotion() ? 'auto' : 'smooth' });
    var cta = u.$('[data-cta]', doc);
    if (cta) win.setTimeout(function () { cta.focus({ preventScroll: true }); }, 500);
  }

  var slotPicker = u.$('[data-slot-picker]', doc);
  if (slotPicker) slotPicker.addEventListener('change', function (e) {
    var m = /^slot-(\d+)$/.exec(e.target.name || '');
    if (!m) return;
    var i = parseInt(m[1], 10);
    if (PDP.state.setSlot(c, s, i, e.target.value)) { render(); track('option_select', { source: 'buybox', unit: i + 1 }); }
    else render();
  });
  var tierPicker = u.$('[data-tier-picker]', doc);
  if (tierPicker) {
    if (!c.showTiers) u.$$('[data-tier]', doc).forEach(function (el) { if (el.getAttribute('data-tier') !== c.tiers[0].id) el.hidden = true; });
    tierPicker.addEventListener('change', function (e) {
      if (e.target.name === 'tier' && PDP.state.setTier(c, s, e.target.value)) { render(); track('tier_select'); }
    });
  }
  u.$$('[data-axis-picker]', doc).forEach(function (fs) {
    fs.addEventListener('change', function (e) {
      var m = /^axis-(.+)$/.exec(e.target.name || '');
      if (m && PDP.state.setSingle(c, s, m[1], e.target.value)) { render(); track('option_select', { source: 'axis', axis: m[1] }); }
    });
  });
  // add-on rows: a checkbox that only changes what Add to cart adds; it has no button of its own
  u.$$('[data-addon]', doc).forEach(function (row) {
    row.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'checkbox') return;
      var id = row.getAttribute('data-addon');
      if (PDP.state.setAddon(c, s, id, e.target.checked)) {
        render();
        track('addon_select', { addon: id, checked: e.target.checked, variant: (PDP.config.addon(c, id) || {}).variant });
      } else render();
    });
  });
  u.$$('[data-pick-value]', doc).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (PDP.state.setAll(c, s, btn.getAttribute('data-pick-value'))) { render(); track('option_select', { source: 'tiles' }); }
      jumpToBuy();
    });
  });
  u.$$('[data-one-of-each]', doc).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!PDP.state.oneOfEach(c, s)) return;
      render(); jumpToBuy();
      track('option_select', { source: 'one_of_each' });
    });
  });
  u.$$('[data-jump-buy]', doc).forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); jumpToBuy(); });
  });
  // bound to the CTA roles (same set render.js drives), not the data-track attribute, which stays optional
  u.$$(PDP.render.CTA, doc).forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (a.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      if (c.mode === 'shopify' && a.classList.contains('is-busy')) { e.preventDefault(); return; }  // add already in flight
      var m = PDP.pricing.tierMath(c, s.tier, PDP.state.units(c, s));
      var extras = PDP.state.addonItems(c, s);
      track('add_to_cart', {
        price: m.priceCents / 100, units: s.slots.slice(), url: a.getAttribute('href') || PDP.cart.permalink(c, s),
        addons: extras.map(function (x) { return x.id; }), addonPrice: PDP.pricing.addonCents(extras) / 100
      });
      if (c.mode !== 'shopify') return;       // static pages follow the cart permalink
      e.preventDefault();
      PDP.cart.add(c, s, a, win);
    });
  });

  PDP.render.bindFallbacks(c, s, doc);
  var gallery = PDP.gallery.init(s, doc, win, track);
  PDP.sticky.init(doc, win);
  PDP.faq.init(doc, track);
  PDP.reveal.init(doc, win);
  if (c.mode === 'shopify') pdpHeaderOffset(doc, win);
  render();
  gallery.sync();
  return { config: c, state: s, render: render, track: track };
};

  PDP.version = '1.3.0';
  window.PDP = PDP;
  function start() {
    try { PDP.instance = PDP.boot(document, window); }
    catch (e) { if (window.console) console.error(e); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
